exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".pagination[data-v-5f4e2bc7]{margin-top:20px;text-align:center}.button-gutter[data-v-5f4e2bc7]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:5px}", "", {"version":3,"sources":["/workspace/src/views/task/pages/ReviewPlanTable.vue"],"names":[],"mappings":"AACA,6BACE,gBAAiB,AACjB,iBAAmB,CACpB,AACD,gCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,OAAS,CACV","file":"ReviewPlanTable.vue","sourcesContent":["\n.pagination[data-v-5f4e2bc7] {\n  margin-top: 20px;\n  text-align: center;\n}\n.button-gutter[data-v-5f4e2bc7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f4e2bc7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/task/pages/ReviewPlanTable.vue
// module id = 5555
// module chunks = 293